"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sideBySideEmbedImage = exports.sideBySidePickImage = exports.dismissSideBySidePlaceholder = exports.setSideBySidePercentage = exports.deleteAtColumnEnd = exports.backspaceAtColumnStart = exports.swapSideBySideOrder = void 0;
var SideBySide_1 = require("ContentTokens/Models/SideBySide");
var Utils_1 = require("Project/QwilrEditor/Utils");
var lodash_1 = require("lodash");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var ShowImagePicker_1 = __importDefault(require("Project/QwilrEditor/ShowImagePicker"));
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var slate_1 = require("slate");
var TelemetryParameterValue_1 = require("Telemetry/TelemetryParameterValue");
var WidgetActions_1 = require("../WidgetActions");
var Types_1 = require("@CommonFrontendBackend/ContentTokens/Types");
var setSideBySidePercentage = function (editor, newPercentage, path) {
    var sideBySideWidget = (0, Utils_1.asSideBySide)(slate_1.Node.descendant(editor, path));
    var nextData = (0, lodash_1.cloneDeep)(sideBySideWidget.data);
    nextData.percent = newPercentage;
    slate_1.Transforms.setNodes(editor, { data: nextData }, { at: path });
};
exports.setSideBySidePercentage = setSideBySidePercentage;
var swapSideBySideOrder = function (editor, path) {
    var sideBySideWidget = (0, Utils_1.asSideBySide)(slate_1.Node.descendant(editor, path));
    var children = (0, lodash_1.cloneDeep)(sideBySideWidget.children);
    var _a = __read(children, 2), col1 = _a[0], col2 = _a[1];
    var newChildren = [col2, col1];
    slate_1.Editor.withoutNormalizing(editor, function () {
        slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
        slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
        slate_1.Transforms.insertNodes(editor, newChildren, { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
    });
    var data = (0, lodash_1.cloneDeep)(sideBySideWidget.data);
    if (data.placeholderIndex) {
        data.placeholderIndex =
            data.placeholderIndex === SideBySide_1.SideBySidePlaceholderIndex.Column2
                ? SideBySide_1.SideBySidePlaceholderIndex.Column1
                : SideBySide_1.SideBySidePlaceholderIndex.Column2;
        slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
    }
};
exports.swapSideBySideOrder = swapSideBySideOrder;
var sideBySidePickImage = function (editor, router, di, path) { return __awaiter(void 0, void 0, Promise, function () {
    var imagePickerResult, url, type, uploadId, metricSource, altDescription, updateData, modificationContext;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, di.invoke(ShowImagePicker_1.default)()];
            case 1:
                imagePickerResult = _a.sent();
                url = imagePickerResult.url, type = imagePickerResult.type, uploadId = imagePickerResult.uploadId, metricSource = imagePickerResult.metricSource, altDescription = imagePickerResult.altDescription;
                updateData = {};
                (0, WidgetActions_1.handleFastUploadResult)(type, updateData, uploadId, url, altDescription);
                (0, WidgetActions_1.handleFastUploadResult)(type, updateData, uploadId, url);
                modificationContext = {
                    imageSource: metricSource,
                    origin: TelemetryParameterValue_1.ContentAddedOrigin.Click,
                };
                router.onEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.SideBySide, {
                    action: EditorTypes_1.SideBySideActionType.EmbedImage,
                    imageData: updateData,
                    modificationContext: modificationContext,
                    path: path,
                }), editor);
                return [2];
        }
    });
}); };
exports.sideBySidePickImage = sideBySidePickImage;
var dismissSideBySidePlaceholder = function (editor, path) {
    var sideBySideWidget = (0, Utils_1.asSideBySide)(slate_1.Node.descendant(editor, path));
    var nextData = (0, lodash_1.cloneDeep)(sideBySideWidget.data);
    nextData.placeholderIndex = null;
    slate_1.Transforms.setNodes(editor, { data: nextData }, { at: path });
};
exports.dismissSideBySidePlaceholder = dismissSideBySidePlaceholder;
var sideBySideEmbedImage = function (editor, path, imageData) {
    var sideBySide = (0, Utils_1.asSideBySide)(slate_1.Node.descendant(editor, path));
    var columnPath = __spreadArray(__spreadArray([], __read(path), false), [sideBySide.data.placeholderIndex - 1], false);
    var _a = __read(slate_1.Editor.nodes(editor, { at: columnPath, match: slate_1.Text.isText, mode: "lowest", voids: true }), 1), textEntry = _a[0];
    var pathForImage = textEntry[1];
    var pointForImage = {
        path: pathForImage,
        offset: 0,
    };
    (0, WidgetActions_1.addImageWidget)(editor, imageData, pointForImage);
    dismissSideBySidePlaceholder(editor, path);
};
exports.sideBySideEmbedImage = sideBySideEmbedImage;
var backspaceAtColumnStart = function (editor) {
    var column = (0, Utils_1.checkAncestors)(editor, editor.selection.anchor.path, function (curr) { return slate_1.Element.isElement(curr) && curr.type === "sideBySideColumn"; });
    if ((0, Utils_1.isAtStartOfNode)(editor.selection.anchor, column)) {
        return true;
    }
};
exports.backspaceAtColumnStart = backspaceAtColumnStart;
var deleteAtColumnEnd = function (editor) {
    var column = (0, Utils_1.checkAncestors)(editor, editor.selection.anchor.path, function (curr) { return slate_1.Element.isElement(curr) && curr.type === "sideBySideColumn"; });
    if ((0, Utils_1.isAtEndOfNode)(editor.selection.anchor, column)) {
        return true;
    }
};
exports.deleteAtColumnEnd = deleteAtColumnEnd;
